import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import { IOrderResponse, IOrderVariables } from './types'
import orderQuery from './query'

const useLazyGetOrder = (
  options?: LazyQueryHookOptions<IOrderResponse, IOrderVariables>,
) => {
  return useLazyQuery<IOrderResponse, IOrderVariables>(orderQuery, options)
}

export { useLazyGetOrder }
